import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Row, Col } from '@vds/grids';
import { reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';

import VdsRadioButton from '../../../../common/RadioButton';
import Button from '../../../../common/Button/index';
import { Body, Title } from '../../../../common/Typography/index';
import { viewport } from '../../../../common/Helpers/index';
import '../creditCheck.css';
import { StyledWrapper } from '../../../ShippingInfo/redesign/shippingStyles';

class EidQuestionnaire extends Component {
  constructor(props) {
    super(props);
    this.state = {
      question: this.props?.eidQuestionnaire?.questionAnswer,
      questionChoice: [],
      isSelected: true,
      option: null,
    };
  }

  onChangeHandler = (data) => {
    const { questionNumber, index } = JSON.parse(data);
    const { questionChoice } = this.state;
    const copyState = [...questionChoice];
    const copyStateAlt = [...questionChoice];
    if (copyStateAlt.find((item) => item.question === questionNumber)) {
      if (copyState.length > 0) {
        copyState.forEach((item) => {
          if (item.question === questionNumber) {
            // eslint-disable-next-line
            item.answer = `${index + 1}`;
          }
        });
      }
    } else {
      const selectedAnswer = {
        question: questionNumber,
        answer: `${index + 1}`,
      };
      copyState.push(selectedAnswer);
    }
    this.setState({
      // eslint-disable-next-line
      ...this.state,
      questionChoice: copyState,
      isSelected: !(copyState?.length === this.props?.eidQuestionnaire?.questionAnswer?.length),
      option: questionNumber,
    });
  };

  render() {
    console.log('render eid quationire---', this.state.isSelected);
    const type = viewport();
    const submitCTA = (
      <Button
        onClick={(e) => {
          e.preventDefault();
          this.props.onSubmit(e, this.state.questionChoice);
        }}
        disabled={this.state.isSelected}
        width="383px"
      >
        Continue
      </Button>
    );
    if (this.props.getEidSubmitCTA) {
      // eslint-disable-next-line react/no-deprecated
      ReactDOM.render(submitCTA, this.props.getEidSubmitCTA);
    }
    const state = [];
    if (this.state.question?.length) {
      this.state.question.forEach((item) => {
        const options = [];
        const choices = [];
        for (const key in item) {
          if (key !== 'questionNumber' && key !== 'questionText') {
            choices.push(item[key]);
          }
        }
        choices.forEach((value, index) => {
          options.push({
            name: value,
            children: value,
            value: JSON.stringify({ q: item.questionText, questionNumber: item.questionNumber, answer: value, index }),
          });
        });
        state.push({
          choices: options,
          questionNumber: item.questionNumber,
          questionText: item.questionText,
        });
      });
    }

    const eidQuestionData = state?.map((questionAnswer) => (
      <Col key={questionAnswer.questionNumber} id={questionAnswer.questionNumber} colSizes={{ mobile: 4, tablet: 6, desktop: 5 }}>
        <Title primitive="p" size="small">
          {questionAnswer.questionNumber} .{questionAnswer.questionText}{' '}
          <StyledWrapper styles="margin: 24px 0px 40px;">
            <VdsRadioButton
              defaultValue="none"
              name="billingAddress"
              containerClassName=""
              onChange={(event) => this.onChangeHandler(event.target.value)}
              data={questionAnswer.choices}
            />
          </StyledWrapper>
        </Title>
      </Col>
    ));
    return (
      <Row className={`${type === 'mobile' ? 'width340' : 'width600'} noLeftMargin`}>
        <div id="eidQuestions" className="contains-PII margin32 onlyTopMargin eidWrapper">
          <Body primitive="p" size="large">
            {eidQuestionData}
          </Body>
        </div>
        <Row>
          {(type === 'mobile' || type === 'tablet') && (
            <Col xs={12} lg={6} md={6} sm={4}>
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  this.props.onSubmit(e, this.state.questionChoice);
                }}
                disabled={this.state.isSelected}
                width={type === 'mobile' ? '100%' : '184px'}
              >
                Continue
              </Button>
            </Col>
          )}
        </Row>
      </Row>
    );
  }
}
EidQuestionnaire.propTypes = {
  getEidSubmitCTA: PropTypes.any,
  eidQuestionnaire: PropTypes.any,
  onSubmit: PropTypes.func,
};
export default reduxForm({})(EidQuestionnaire);
